/**
 * leadStatus — Lead/Kontakt durumları için TEK kaynak.
 *
 * Konsolidasyon (2026-07):
 *   Potenzieller Interessent            → değişmedi
 *   Interessiert + Interessent          → "Interessenten"
 *   Angebot versendet, Bedarfsabfrage   → KALDIRILDI (→ Interessenten)
 *   Kunde                               → değişmedi
 *   Nicht interessiert + Deaktiviert +
 *   Verlorener Kunde                    → "Verlorene Kunden"
 *   + Yeni kanal durumları: eBay, Shopify
 */

export const LEAD_STATUSES = [
  'Potenzieller Interessent',
  'Interessenten',
  'Kunde',
  'Verlorene Kunden',
  'eBay',
  'Shopify',
];

/** Eski değer → yeni değer eşlemesi (okuma sırasında da normalize edilir). */
const LEGACY_MAP = {
  'Interessiert': 'Interessenten',
  'Interessent': 'Interessenten',
  'Angebot versendet': 'Interessenten',
  'Bedarfsabfrage': 'Interessenten',
  'Nicht interessiert': 'Verlorene Kunden',
  'Deaktiviert': 'Verlorene Kunden',
  'Verlorener Kunde': 'Verlorene Kunden',
};

export function normalizeLeadStatus(status) {
  if (!status) return status;
  return LEGACY_MAP[status] || status;
}

export const isCustomerStatus = (s) =>
  ['Kunde', 'eBay', 'Shopify'].includes(normalizeLeadStatus(s));
export const isLostStatus = (s) => normalizeLeadStatus(s) === 'Verlorene Kunden';

/** Durum rozet renkleri (StatusBadge ile uyumlu Tailwind sınıfları). */
export const LEAD_STATUS_STYLES = {
  'Potenzieller Interessent': 'bg-purple-50 text-purple-700 border-purple-200',
  'Interessenten': 'bg-amber-50 text-amber-700 border-amber-200',
  'Kunde': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Verlorene Kunden': 'bg-red-50 text-red-600 border-red-200',
  'eBay': 'bg-yellow-50 text-yellow-700 border-yellow-200',
  'Shopify': 'bg-green-50 text-green-700 border-green-200',
};

/**
 * Mükerrer müşteri kuralı: aynı isimli kayıt YALNIZCA adresi farklıysa
 * kabul edilir. Aynı isim + aynı adres → duplikat.
 * @returns {object|null} çakışan mevcut lead ya da null
 */
export function findDuplicateCustomer(leads, { name, strasse, plz, ort, excludeId = null }) {
  const norm = (v) => (v || '').trim().toLowerCase();
  const nName = norm(name);
  if (!nName) return null;
  const nAddr = [norm(strasse), norm(plz), norm(ort)].join('|');
  return leads.find((l) => {
    if (excludeId && l.id === excludeId) return false;
    if (norm(l.name) !== nName) return false;
    const lAddr = [norm(l.strasse), norm(l.plz), norm(l.ort)].join('|');
    return lAddr === nAddr; // aynı adres → duplikat; farklı adres → izinli
  }) || null;
}
